import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.171 4.658A1.5 1.5 0 0 0 12.6 4.8L6 9H3a1.5 1.5 0 0 0-1.5 1.5v3A1.5 1.5 0 0 0 3 15h3l6.6 4.2A1.5 1.5 0 0 0 15 18V6a1.5 1.5 0 0 0-.829-1.342v0Zm7.292 11.092a6.6 6.6 0 0 0 0-7.1m-2.901 5.791a3.493 3.493 0 0 0 0-4.405M6 9v6",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M14.171%204.658A1.5%201.5%200%200%200%2012.6%204.8L6%209H3a1.5%201.5%200%200%200-1.5%201.5v3A1.5%201.5%200%200%200%203%2015h3l6.6%204.2A1.5%201.5%200%200%200%2015%2018V6a1.5%201.5%200%200%200-.829-1.342v0Zm7.292%2011.092a6.6%206.6%200%200%200%200-7.1m-2.901%205.791a3.493%203.493%200%200%200%200-4.405M6%209v6%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
